export const ZOOM_LEVELS = [1, 1.5, 2.0, 2.5];
export const MIN_ZOOM = ZOOM_LEVELS[0];
export const MAX_ZOOM = ZOOM_LEVELS[ZOOM_LEVELS.length - 1];

export const DEFAULT_HEIGHT = 480;
export const MIN_HEIGHT = 152;
export const MAX_HEIGHT = 560;

// Below these native dimensions, a small-supplement chip's fullscreen button (top-right)
// can cover the whole visible image, so we reserve space above it instead.
export const SMALL_IMAGE_CHIP_MAX_WIDTH = 200;
export const SMALL_IMAGE_CHIP_MAX_HEIGHT = 120;
